


























import { VueCustom, CustomVueConstructor } from 'vue-custom';
import { Element } from 'types';
import { isIOS } from 'utils';
import { mapGetters } from 'stores';

import ScrollManager from 'managers/scroll.manager';
import { LIBRARY_ID } from 'constants/drag';

import LibraryBox from './box.vue';
import LibraryBoxLite from './box-lite.vue';

const KEEP_ABOVE = 5;
const KEEP_MIN = 15;

const FIRST_OF_TYPE_MARGIN_TOP = 10;

type ComponentCustom = {
  lastY: number,
  _startIndex: number,
  _KEEP: number,
  _elementOuterHeight: number,
};
export default (VueCustom as CustomVueConstructor<ComponentCustom>).extend({
  name: 'library-scroller',
  props: {
    elements: Array as PropType<Element[]>,
  },
  components: {
    LibraryBox,
    LibraryBoxLite,
  },
  data: () => ({
    starting: 0,
    reloading: false,
  }),
  computed: {
    ...mapGetters({
      libraryElementsIds: 'library',
      hasElements: 'hasLibrary',
      isSearchActive: 'isSearchActive',
      searchQuery: 'searchQuery',
      inArtMode: 'isArtModeEnabled',
      boxDimensions: 'libraryBoxDimensions',
    }),
    shouldUseLiteBox(): boolean {
      return this.inArtMode;
    },
    elementsCount(): number {
      return this.elements.length;
    },
    elementsList(): Element[] {
      if (this.elementsCount < this.KEEP) {
        return this.elements;
      }

      const start = this.startIndex;
      const breakingIndex = (this.KEEP - this.startIndex) % this.KEEP;
      const elements = this.elements.slice(start, start + this.KEEP);
      const toAdd = elements.slice(breakingIndex, elements.length);
      elements.splice(breakingIndex, elements.length);
      elements.unshift(...toAdd);

      return elements;
    },
    elementHeight(): number {
      return this.boxDimensions.height;
    },
    elementOuterHeight(): number {
      return this.elementHeight + this.boxDimensions.margin;
    },
    totalHeight(): number {
      const fix = isIOS() ? 5 : 0;
      const elementsHeight = this.elementsCount * this.elementOuterHeight;
      return fix + FIRST_OF_TYPE_MARGIN_TOP + elementsHeight;
    },
    styles(): any {
      return {
        opacity: this.reloading ? 0 : 1,
        height: `${ this.totalHeight }px`,
        contain: 'layout',
      };
    },
    scrollerHeight(): number {
      const droppable = this.$store.getters.droppableStaticById(LIBRARY_ID);
      return droppable!.dimensions.height;
    },

    startIndex(): number {
      let start = this.starting - KEEP_ABOVE;
      if (start + this.KEEP > this.elementsCount) {
        start = this.elementsCount - this.KEEP;
      }

      return Math.max(start, 0);
    },
    KEEP(): number {
      const count = Math.ceil(this.scrollerHeight / this.elementHeight) + 6;
      return Math.max(KEEP_MIN, count);
    },
  },
  mounted() {
    this.initScroll();
    this.lastY = 0;
    this._startIndex = 0;
    this._KEEP = this.KEEP;
    this._elementOuterHeight = this.elementOuterHeight;
  },
  watch: {
    searchQuery(query, old) {
      if (query === old || query === null || !query.length) return;

      this.$nextTick(() => {
        this.setStarting(0);
        this.$nextTick(() => ScrollManager.scrollTop(0));
      });
    },
    isSearchActive(isActive) {
      if (isActive) return;

      this.reloading = true;
      this.$nextTick(() => window.setTimeout(() => { this.reloading = false; }, 50));
    },
    async inArtMode(active) {
      if (!active) return;

      await ScrollManager.onInit();
      if (ScrollManager.handler) {
        ScrollManager.handler.refresh();
      }
    },
    startIndex(value) {
      // non reactive copy
      this._startIndex = value;
    },
    KEEP(value) {
      // non reactive copy
      this._KEEP = value;
    },
    elementOuterHeight(value) {
      // non reactive copy
      this._elementOuterHeight = value;
    },
  },
  methods: {
    async initScroll() {
      await ScrollManager.onInit();
      await ScrollManager.handler.reinitialize();

      this.handleScroll = this.handleScroll.bind(this);
      ScrollManager.handler.onScroll((position) => {
        this.lastY = position.y;
        window.requestAnimationFrame(() => this.handleScroll());
      });
    },

    // @ts-ignore
    handleScroll(y: number = this.lastY) {
      const starting = Math.max(0, Math.floor(y / this.elementOuterHeight));
      if (this.starting === starting) return;

      this.setStarting(starting);
    },
    setStarting(starting: number) {
      this.starting = starting;
    },
    getKey(index: number) {
      const start = this._startIndex % this._KEEP;
      return Math.abs(start - index - this._KEEP) % this._KEEP;
    },
    getStyle(index: number) {
      const key = this.getKey(index);
      const y = FIRST_OF_TYPE_MARGIN_TOP + ((this._startIndex + key) * this._elementOuterHeight);

      return {
        transform: `translate3d(0, ${ y }px, 0)`,
      };
    },
  },
});
